export const ActivitiesMortgagesPermissions = {
  ViewMortgageActivities :  {
    components: null ,  
    componentsId: null , 
    permissionsId: '09da13d4-4952-42a2-72fc-08da8b23d4e4' , 
    permissionsName: 'View Mortgage Activities'  ,  
  }
};
